export default function PlayerWindows() {
  return (
    <div className="prose">
      <h2>Windows</h2>
      <p>Installation and configuration for Windows-based Q-Play players.</p>
      <ul>
        <li>Download installer — Todo</li>
        <li>Auto-start and kiosk mode — Todo</li>
        <li>Codec/driver recommendations — Todo</li>
      </ul>
    </div>
  )
}
